export const baseClasses = `
  inline-flex items-center gap-2
  cursor-pointer transition-colors whitespace-nowrap
  no-underline
  disabled:cursor-not-allowed
`;

export const variantClasses = {
  primary: `
    justify-center rounded-md!
    bg-primary text-white border-2 border-transparent
    font-semibold
    text-base! leading-normal!
    px-4 py-1.5
    disabled:opacity-50
    hover:bg-primary-hover
  `,
  actionOutline: `
    justify-start rounded-action!
    bg-transparent border border-action
    text-action! visited:text-action!
    text-action-body leading-action
    font-action-sans font-action
    min-w-0 h-action-height
    px-action-x py-action-y
    text-left visited:no-underline
    disabled:opacity-60
    [&_svg_path]:fill-action visited:[&_svg_path]:fill-action
    hover:bg-action hover:text-surface!
    focus-visible:bg-action focus-visible:text-surface!
    hover:[&_svg_path]:fill-surface focus-visible:[&_svg_path]:fill-surface
    aria-disabled:bg-transparent! aria-disabled:border-border! aria-disabled:text-subtle!
    aria-disabled:hover:bg-transparent! aria-disabled:hover:border-border! aria-disabled:hover:text-subtle!
    aria-disabled:[&_svg_path]:fill-subtle aria-disabled:hover:[&_svg_path]:fill-subtle
  `,
  // Header logout: 40px box, Sand hairline and a Graphite label at the nav's size.
  navOutline: `
    justify-center rounded-sm!
    bg-transparent border border-accent-surface
    text-content!
    text-lg! leading-normal!
    h-action-height px-action-x
    disabled:opacity-50
    hover:border-action hover:text-action!
  `,
  // Chromeless, for buttons that sit among the header's links; the
  // .d-navbar .nav-link rule supplies their size, colour and hover.
  navLink: `
    justify-center border-0
    bg-transparent
  `,
  outline: `
    justify-center rounded-md!
    bg-transparent border border-border text-subtle
    font-semibold
    text-base! leading-normal!
    px-4 py-1.5
    disabled:opacity-50
    hover:bg-surface-alt hover:text-content
  `,
  // For buttons sitting on an Ocean fill, where the palette pairs Ivory on Ocean.
  outlineOnPrimary: `
    justify-center rounded!
    bg-transparent border border-surface text-surface!
    font-semibold
    text-base! leading-normal!
    h-action-height px-action-x
    disabled:opacity-50
    hover:bg-surface hover:text-primary!
  `,
  outlinePrimary: `
    justify-center rounded-md!
    bg-transparent border border-primary text-primary
    font-semibold
    text-base! leading-normal!
    px-4 py-1.5
    disabled:opacity-50
    hover:bg-primary hover:text-white
  `,
  ghost: `
    justify-center border-0
    bg-transparent text-content
    font-semibold
    text-base! leading-normal!
    px-4 py-1.5
    disabled:opacity-50
    hover:text-primary
  `,
  link: `
    justify-center border-0 p-0
    bg-transparent text-primary font-semibold
    disabled:opacity-50
    hover:text-primary-hover
  `,
  danger: `
    justify-center rounded-md!
    bg-danger text-white border-2 border-transparent
    font-semibold
    text-base! leading-normal!
    px-4 py-1.5
    disabled:opacity-50
    hover:opacity-90
  `,
  close: `
    justify-center border-0! p-0!
    bg-transparent text-content
    font-semibold text-base! leading-normal!
    disabled:opacity-60
    hover:opacity-80
  `,
  tab: `
    bg-transparent
    disabled:opacity-60
  `,
  // Compact secondary action living inside a table row: a 32px outlined chip
  // carrying an icon and a short label. Border only at rest, filling on hover.
  rowAction: `
    justify-center rounded-md!
    bg-transparent border border-primary
    text-primary! visited:text-primary!
    font-semibold
    text-sm! leading-none!
    h-8 px-2.5 py-0!
    disabled:opacity-50
    hover:bg-primary hover:text-surface!
    [&_svg_path]:fill-primary hover:[&_svg_path]:fill-surface
  `,
  iconOutline: `
    justify-center rounded-md!
    bg-surface border border-primary text-primary
    w-8 h-8 p-0!
    text-sm! leading-none!
    transition-all
    disabled:opacity-50
    hover:bg-primary hover:text-white hover:scale-105
    [&_svg_path]:fill-primary hover:[&_svg_path]:fill-white
  `,
  iconGhost: `
    justify-center rounded-md!
    bg-transparent border border-transparent text-subtle
    w-6.25 h-6.25 p-0!
    text-sm! leading-none!
    transition-colors
    disabled:opacity-50
    hover:border-subtle hover:bg-primary/10
  `,
  iconHeader: `
    justify-center rounded-full!
    bg-surface border border-border text-content
    w-10 h-10 p-0!
    text-base! leading-none!
    transition-colors
    disabled:opacity-60
    hover:not-disabled:border-primary hover:not-disabled:text-primary hover:not-disabled:bg-primary/[0.08]
    aria-pressed:border-primary aria-pressed:text-primary aria-pressed:bg-primary/[0.08]
  `,
};

// optional overrides; use ! to guarantee precedence over the variant's default padding/radius
export const sizeClasses = {
  sm: 'text-xs! px-2.5! py-0.5! rounded!',
  lg: 'text-lg! px-10! py-4! rounded-full! font-medium!',
};
